// extracted by mini-css-extract-plugin
module.exports = {"close":"Close_close__2U_N0","icon":"Close_icon__FYlA6"};